var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialAdvisorsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    rx: 35.5,
    fill: "#1D91C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 52.0523V51.4206C53.3153 50.0307 53.2529 49.083 53.2529 47.1877V31.7094C53.2529 23.8123 52.3169 18 36.8424 18C23.9261 18 18.9967 22.1065 18.9967 29.1191H31.4762C31.7882 26.2762 34.2217 25.8971 36.0312 25.8971C37.4039 25.8971 40.2742 26.213 40.2742 28.6137C40.2742 34.8051 17 27.982 17 43.0181C17 49.9043 22.491 53 28.6683 53C33.5353 53 37.2791 51.9892 40.9606 48.5144L41.5846 52.0523H55ZM34.5337 45.5451C31.9754 45.5451 30.4154 44.4079 30.4154 42.7653C30.4154 38.4693 36.0312 39.4801 40.2742 37.3953C40.5862 41.944 39.0887 45.5451 34.5337 45.5451Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialAdvisorsIcon);
export default __webpack_public_path__ + "static/media/financial_advisors_icon.a8f701cf7377339e5a1195cab7113e19.svg";
export { ForwardRef as ReactComponent };